import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

function renderArticleType(articleType) {
  if (Number(articleType) === 2) {
    return "Gjysëm Produkt";
  }
  if (Number(articleType) === 3) {
    return "Produkt i Prodhuar";
  }
  return "-";
}

export default function StandardNormativViewModal({
  show,
  onHide,
  data,
  loading = false,
}) {
  const components = data?.components || [];
  const articleTypeLabel = renderArticleType(data?.articleType);
  const totalComponents = components.length;
  const totalQty = components.reduce((sum, item) => sum + Number(item.Qty || 0), 0);

  return (
    <Modal show={show} onHide={onHide} centered size="xl" className="SNP__view-modal">
      <Modal.Header closeButton className="SNP__view-modal-header">
        <Modal.Title className="SNP__view-modal-title">Pamja e Normativit</Modal.Title>
      </Modal.Header>

      <Modal.Body className="SNP__view-modal-body">
        {loading ? (
          <div className="SNP__view-loading">Duke ngarkuar të dhënat...</div>
        ) : (
          <>
            <section className="SNP__view-hero">
              <div className="SNP__view-hero-main">
                <div className="SNP__view-hero-overline">Artikulli i prodhuar</div>
                <h3 className="SNP__view-hero-title">{data?.articleName || "-"}</h3>
                <div className="SNP__view-hero-meta">
                  <span className="SNP__view-chip">Barkodi: {data?.barcode || "-"}</span>
                  <span className="SNP__view-chip">Njësia: {data?.unitName || "-"}</span>
                  <span className="SNP__view-chip SNP__view-chip--accent">{articleTypeLabel}</span>
                </div>
              </div>

              <div className="SNP__view-hero-stats">
                <div className="SNP__view-stat-card">
                  <span className="SNP__view-stat-label">Komponentë</span>
                  <strong className="SNP__view-stat-value">{totalComponents}</strong>
                </div>
                <div className="SNP__view-stat-card">
                  <span className="SNP__view-stat-label">Totali i sasive</span>
                  <strong className="SNP__view-stat-value">{totalQty.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong>
                </div>
              </div>
            </section>

            <div className="SNP__view-components-wrap">
              <div className="SNP__view-components-head">
                <div className="SNP__view-components-title">Komponentët e Normativit</div>
                <div className="SNP__view-components-count">Gjithsej: {totalComponents}</div>
              </div>

              <div className="table-responsive">
                <table className="table table-sm align-middle SNP__view-components-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Barkodi</th>
                      <th>Emërtimi</th>
                      <th>Njësia</th>
                      <th className="text-end">Sasia</th>
                    </tr>
                  </thead>
                  <tbody>
                    {components.length === 0 ? (
                      <tr>
                        <td colSpan={5} className="text-center text-muted py-3">
                          Ky normativ nuk ka komponentë të regjistruar.
                        </td>
                      </tr>
                    ) : (
                      components.map((item, index) => (
                        <tr key={item.ArticleComponentsID || `${item.ArticlesID}-${index}`}>
                          <td>{index + 1}</td>
                          <td>{item.Barcode || "-"}</td>
                          <td>{item.ArticleName || "-"}</td>
                          <td>{item.UnitName || "-"}</td>
                          <td className="text-end">{Number(item.Qty || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
      </Modal.Body>

      <Modal.Footer className="SNP__view-modal-footer">
        <Button variant="secondary" onClick={onHide} className="SNP__view-close-btn">
          Mbyll
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
